import React from "react";
import { useIntl } from "react-intl";
import { ReactComponent as TentIcon } from "../../assets/illustrations/tent.svg";
import { Organization } from "../../types";
import { LazyImageRenderer } from "@hooplab/ui-components";
import * as styles from "./styles";

interface IProps {
  organization: Organization;
  size?: number;
}

const OrganizationImage: React.FC<IProps> = ({ organization, size = 32 }) => {
  const intl = useIntl();
  return (
    <div className={styles.orgImage} data-nosnippet>
      {organization.images ? (
        <LazyImageRenderer
          alt={intl.formatMessage({
            id: "components.OrganizationImage.alt",
            defaultMessage: "Organization image",
          })}
          imgixImage={organization.image}
          croppedImages={organization.images}
          env={window.ENVIRONMENT.__IMGIX_ENV__}
          queries={[]}
          style={{ width: size, height: size, borderRadius: "100%", aspectRatio: "1/1" }}
          base={{ width: size * 2, ar: "Square" }}
        />
      ) : (
        <span className={styles.emptyImage} style={{ height: size, width: size, minWidth: size }}>
          <TentIcon height={size - 12} />
        </span>
      )}
    </div>
  );
};

export default OrganizationImage;
